'use client'

import Image from 'next/image'
import AngleDownIcon from '@/public/images/icons/angle-down.svg'
import { useSearchParams } from 'next/navigation'
import { useState } from 'react'
import { min } from 'lodash'

export default function LoadMore({ totalPages }: { totalPages: number }) {
  const searchParams = useSearchParams()
  const [page, setPage] = useState<number>(
    Number(searchParams.get('page')) || 1
  )

  const handleLoadMore = (pageNumber: number) => {
    const params = new URLSearchParams(searchParams)
    params.set('page', pageNumber.toString())
    setPage(Number(min([totalPages, pageNumber])))

    window.history.replaceState(null, '', `?${params.toString()}`)
  }

  return (
    <div
      onClick={() => handleLoadMore(page + 1)}
      className="flex items-center justify-center mt-6 text-sm font-medium cursor-pointer gap-2"
    >
      Load More
      <Image
        src={AngleDownIcon}
        alt="Load More"
        style={{
          maxWidth: '100%',
          height: 'auto',
        }}
      />
    </div>
  )
}
